import { atom } from 'recoil'

export const assetState = atom({
    key: 'assetState',
    default: [],
});